// TODO: Eventually this will get moved out to the DB once we decide

import { PrimaryUses } from './facility'

// how we are going to handle additional detailed obstructions
export type DetailedObstruction = {
  obstructionType: string
  width: number
  length: number
  height: number
  resizable: boolean
  tags: string[]
  primaryUses: PrimaryUses[]
  rotation?: { x: number; y: number; z: number }
}
const detailedObstructions: DetailedObstruction[] = [
  {
    obstructionType: 'AlignmentRack',
    width: 12,
    length: 6,
    height: 64,
    resizable: true,
    tags: ['alignment', 'racking', 'shelf', 'shelves', 'warehouse', 'shop'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'AlignmentRackUp',
    width: 12,
    length: 6,
    height: 78,
    resizable: true,
    tags: ['alignment', 'racking', 'shelf', 'shelves', 'warehouse', 'shop'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Ambulance',
    width: 8,
    length: 22,
    height: 105,
    resizable: true,
    tags: ['ambulance', 'vehicle', 'service', 'emergency'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'AllInOne1',
    width: 3,
    length: 4.8,
    height: 75,
    resizable: true,
    tags: ['fitness', 'all', 'in', 'one', 'gym', 'workout'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'AllInOne2',
    width: 3,
    length: 5,
    height: 65,
    resizable: true,
    tags: ['fitness', 'all', 'in', 'one', 'gym', 'workout'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'AllInOneWeightless',
    width: 2,
    length: 4.4,
    height: 85,
    resizable: true,
    tags: ['fitness', 'weightless', 'all', 'in', 'one', 'gym', 'workout'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Bench',
    width: 1.5,
    length: 5,
    height: 50,
    resizable: true,
    tags: ['fitness', 'workout', 'bench', 'diy', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Bike',
    width: 1.8,
    length: 3.7,
    height: 60,
    resizable: true,
    tags: ['fitness', 'bike', 'gym', 'legs', 'workout'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Boeing787',
    width: 183,
    length: 172,
    height: 170,
    resizable: true,
    tags: ['boeing', '787', 'plane', 'jet', 'aircraft'],
    primaryUses: ['HANGAR'],
  },
  {
    obstructionType: 'Car',
    width: 6,
    length: 12,
    height: 55,
    resizable: true,
    tags: ['car', 'vehicle', 'sedan'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER', 'AUTOMOTIVE_SHOWROOM'],
  },
  {
    obstructionType: 'CarLift',
    width: 5,
    length: 10,
    height: 105,
    resizable: true,
    tags: ['carlift', 'garage', 'shop'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'CarLiftUp',
    width: 5,
    length: 10,
    height: 105,
    resizable: true,
    tags: ['carlift', 'garage', 'shop'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'CarLift2',
    width: 5,
    length: 10,
    height: 105,
    resizable: true,
    tags: ['carlift', 'garage', 'shop'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Chair',
    width: 2.5,
    length: 2.5,
    height: 36,
    resizable: true,
    tags: ['chair', 'home', 'living room'],
    primaryUses: ['RESIDENTIAL'],
  },
  {
    obstructionType: 'Charter Bus',
    width: 9,
    length: 48,
    height: 160,
    resizable: true,
    tags: ['charter', 'bus', 'vehicle', 'transportation', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'CncMachine1',
    width: 7,
    length: 5.8,
    height: 95,
    resizable: true,
    tags: ['manufacturing', 'cnc', 'machine'],
    primaryUses: ['MANUFACTURING'],
  },
  {
    obstructionType: 'CncMachine2',
    width: 3,
    length: 3,
    height: 25,
    resizable: true,
    tags: ['manufacturing', 'cnc', 'machine'],
    primaryUses: ['MANUFACTURING'],
  },
  {
    obstructionType: 'CoffeeTable',
    width: 2,
    length: 3.5,
    height: 24,
    resizable: true,
    tags: ['table', 'home', 'living room', 'coffee table'],
    primaryUses: ['RESIDENTIAL'],
  },
  {
    obstructionType: 'Coil',
    width: 4,
    length: 4,
    height: 49,
    resizable: true,
    tags: ['coil', 'parts', 'shop', 'warehouse'],
    primaryUses: ['WAREHOUSE', 'SHIPPING_RECEIVING', 'MANUFACTURING', 'STORAGE_RACKING', 'PICKING_SORTING'],
  },
  {
    obstructionType: 'Conveyor',
    width: 2.5,
    length: 10,
    height: 40,
    resizable: true,
    tags: ['manufacturing', 'conveyor', 'belt', 'assembly', 'line'],
    primaryUses: ['MANUFACTURING'],
  },
  {
    obstructionType: 'Couch',
    width: 6,
    length: 3,
    height: 36,
    resizable: true,
    tags: ['couch', 'home', 'living room'],
    primaryUses: ['OFFICE', 'RESIDENTIAL'],
  },
  {
    obstructionType: 'Cow',
    width: 2.6,
    length: 8.7,
    height: 65,
    resizable: true,
    tags: ['cow', 'animal', 'agriculture', 'farm', 'barn'],
    primaryUses: ['AGRICULTURE'],
  },
  {
    obstructionType: 'Cubicle',
    width: 8.7,
    length: 8.7,
    height: 65,
    resizable: true,
    tags: ['desk', 'office', 'cubicle'],
    primaryUses: ['OFFICE'],
  },
  {
    obstructionType: 'DeliveryTruck',
    width: 8.6,
    length: 25,
    height: 120,
    resizable: true,
    tags: ['delivery', 'truck', 'cargo', 'service', 'vehicle'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'DodgeRamDually',
    width: 8,
    length: 21,
    height: 77,
    resizable: true,
    tags: ['dodge', 'ram', 'dually', 'truck', 'pickup', 'vehicle'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER', 'AUTOMOTIVE_SHOWROOM'],
  },
  {
    obstructionType: 'DoubleRackingEmpty',
    width: 7,
    length: 10,
    height: 200,
    resizable: true,
    tags: ['racking', 'rack', 'storage', 'shelf', 'shelves', 'warehouse'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'DoubleRackingWithBoxes',
    width: 7,
    length: 10,
    height: 200,
    resizable: true,
    tags: ['racking', 'rack', 'storage', 'shelf', 'shelves', 'warehouse'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'DumbbellRack',
    width: 5,
    length: 1.6,
    height: 40,
    resizable: true,
    tags: ['fitness', 'dumbbell', 'rack', 'weights', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Elliptical',
    width: 2,
    length: 4.7,
    height: 55,
    resizable: true,
    tags: ['fitness', 'elliptical', 'workout', 'legs', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'F16',
    width: 35,
    length: 49,
    height: 170,
    resizable: true,
    tags: ['f16', '16', 'plane', 'jet', 'aircraft'],
    primaryUses: ['HANGAR'],
  },
  {
    obstructionType: 'FireTruck',
    width: 11,
    length: 35,
    height: 160,
    resizable: true,
    tags: ['firetruck', 'vehicle', 'service', 'emergency'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Fleetwood',
    width: 7,
    length: 18,
    height: 52,
    resizable: true,
    tags: ['car', 'sedan', 'vehicle', 'cadillac', 'fleetwood', 'classic'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER', 'AUTOMOTIVE_SHOWROOM'],
  },
  {
    obstructionType: 'Forklift',
    width: 4.3,
    length: 11,
    height: 75,
    resizable: true,
    tags: ['forklift', 'service', 'vehicle', 'warehouse'],
    primaryUses: ['WAREHOUSE', 'SHIPPING_RECEIVING', 'MANUFACTURING', 'STORAGE_RACKING', 'PICKING_SORTING'],
  },
  {
    obstructionType: 'G450',
    width: 80,
    length: 85,
    height: 170,
    resizable: true,
    tags: ['G450', '450', 'plane', 'jet', 'aircraft', 'private'],
    primaryUses: ['HANGAR'],
  },
  {
    obstructionType: 'HeavyBagStand',
    width: 5,
    length: 5,
    height: 60,
    resizable: true,
    tags: ['fitness', 'punching', 'bag', 'stand', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Horse',
    width: 2.4,
    length: 8.7,
    height: 80,
    resizable: true,
    tags: ['agriculture', 'animal', 'horse', 'barn'],
    primaryUses: ['AGRICULTURE'],
  },
  {
    obstructionType: 'KingBed',
    width: 7,
    length: 5.5,
    height: 48,
    resizable: true,
    tags: ['bed', 'bedroom'],
    primaryUses: ['OFFICE', 'RESIDENTIAL'],
  },
  {
    obstructionType: 'Lathe',
    width: 14,
    length: 5.6,
    height: 100,
    resizable: true,
    tags: ['manufacturing', 'lathe', 'metal'],
    primaryUses: ['MANUFACTURING'],
  },
  {
    obstructionType: 'LatPulldown',
    width: 2,
    length: 2,
    height: 70,
    resizable: true,
    tags: ['fitness', 'pulldown', 'lateral', 'arm', 'workout', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'LegMachine',
    width: 3.8,
    length: 5,
    height: 50,
    resizable: true,
    tags: ['fitness', 'legs', 'workout', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'LegMachine2',
    width: 3,
    length: 3.5,
    height: 80,
    resizable: true,
    tags: ['fitness', 'legs', 'workout', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Mercedes',
    width: 6,
    length: 15,
    height: 50,
    resizable: true,
    tags: ['car', 'vehicle', 'mercedes', 'sportscar'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER', 'AUTOMOTIVE_SHOWROOM'],
  },
  {
    obstructionType: 'OfficeChair',
    width: 2,
    length: 2,
    height: 48,
    resizable: true,
    tags: ['office', 'chair', 'desk'],
    primaryUses: ['OFFICE', 'RESIDENTIAL'],
  },
  {
    obstructionType: 'Pallet',
    width: 4,
    length: 3.5,
    height: 8,
    resizable: true,
    tags: ['pallet', 'warehouse', 'shop'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'PalletWithBoxes',
    width: 2.5,
    length: 3.7,
    height: 25,
    resizable: true,
    tags: ['pallet', 'warehouse', 'shop'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'PoliceCharger',
    width: 6,
    length: 17,
    height: 60,
    resizable: true,
    tags: ['police', 'cop', 'car', 'charger', 'vehicle', 'service', 'emergency'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'PoliceSUV',
    width: 6,
    length: 17,
    height: 70,
    resizable: true,
    tags: ['police', 'cop', 'suv', 'vehicle', 'service', 'emergency'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'PoliceSUV2',
    width: 6,
    length: 17,
    height: 75,
    resizable: true,
    tags: ['police', 'cop', 'suv', 'vehicle', 'service', 'emergency'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Racking Empty',
    width: 3,
    length: 10,
    height: 200,
    resizable: true,
    tags: ['racking', 'rack', 'storage', 'shelf', 'shelves', 'warehouse'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'Racking With Boxes',
    width: 3,
    length: 10,
    height: 200,
    resizable: true,
    tags: ['racking', 'rack', 'boxes', 'storage', 'shelf', 'shelves', 'warehouse'],
    primaryUses: ['MANUFACTURING', 'PICKING_SORTING', 'SHIPPING_RECEIVING', 'STORAGE_RACKING', 'WAREHOUSE'],
  },
  {
    obstructionType: 'SchoolBus',
    width: 9,
    length: 40,
    height: 160,
    resizable: true,
    tags: ['school', 'bus', 'service', 'vehicle', 'transportation'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Semi1',
    width: 8,
    length: 55,
    height: 170,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Semi2',
    width: 8,
    length: 62,
    height: 160,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Semi4',
    width: 8,
    length: 60,
    height: 160,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'SemiCab',
    width: 10,
    length: 22,
    height: 162,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'SemiCab2',
    width: 9,
    length: 24,
    height: 158,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Staircase',
    width: 9,
    length: 24,
    height: 158,
    resizable: true,
    tags: ['staircase', 'stair', 'escalator', 'floors', 'levels'],
    primaryUses: ['OFFICE', 'CHURCH_RELIGION'],
  },
  {
    obstructionType: 'Student Desk',
    width: 1.89,
    length: 2.58,
    height: 35.75,
    resizable: true,
    tags: ['school', 'desk', 'classroom', 'student'],
    primaryUses: ['OFFICE', 'CLASSROOM'],
  },
  {
    obstructionType: 'TankerSemi',
    width: 8,
    length: 62,
    height: 148,
    resizable: true,
    tags: ['semi', 'vehicle', 'trailer', 'truck', 'cargo', 'service', 'tanker'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Taxi',
    width: 6,
    length: 18,
    height: 74,
    resizable: true,
    tags: ['taxi', 'service', 'transportation', 'cab', 'uber'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'TeacherDesk',
    width: 2.2,
    length: 5.8,
    height: 40,
    resizable: true,
    tags: ['school', 'desk', 'classroom', 'teacher'],
    primaryUses: ['OFFICE', 'CLASSROOM', 'RESIDENTIAL'],
  },
  {
    obstructionType: 'Transit Bus',
    width: 8,
    length: 40,
    height: 128,
    resizable: true,
    tags: ['transit', 'bus', 'service', 'vehicle', 'transportation'],
    primaryUses: ['AUTOMOTIVE_SERVICE_CENTER'],
  },
  {
    obstructionType: 'Treadmill',
    width: 2.5,
    length: 5.5,
    height: 40,
    resizable: true,
    tags: ['fitness', 'leg', 'workout', 'gym', 'treadmill'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'WeightBench',
    width: 4,
    length: 4.2,
    height: 50,
    resizable: true,
    tags: ['fitness', 'arms', 'workout', 'weight', 'bench', 'gym'],
    primaryUses: ['CARDIO_EQUIPMENT', 'GROUP_EXERCISE_ROOM', 'STRENGTH_TRAINING'],
  },
  {
    obstructionType: 'Worker',
    width: 3,
    length: 3,
    height: 74,
    resizable: false,
    tags: ['person', 'worker', 'model', 'construction'],
    primaryUses: [
      'AUTOMOTIVE_SERVICE_CENTER',
      'CARDIO_EQUIPMENT',
      'GROUP_EXERCISE_ROOM',
      'MANUFACTURING',
      'STRENGTH_TRAINING',
      'WAREHOUSE',
    ],
  },
  {
    obstructionType: 'Yacht',
    width: 8,
    length: 53,
    height: 74,
    resizable: true,
    tags: ['yacht', 'boat', 'transportation'],
    primaryUses: [],
  },
]

export default detailedObstructions
